<template>
  <div class="analyse-container animate__animated animate__fadeIn">
    <div class="page-content" style="width:339px">
      <el-input placeholder="输入关键字进行过滤" size="mini" v-model="filterText" clearable></el-input>
      <el-tree ref="tree" style="margin-top:10px" class="filter-tree" :filter-node-method="filterNode" :data="treeData"
        node-key="id" highlight-current default-expand-all @node-click="handleNodeClick" :expand-on-click-node="false">
        <span class="custom-tree-node" slot-scope="{ node, data }">
          <!-- 如果有子节点，显示files.png（打开的文件夹图标） -->
          <img v-if="data.children" :src="require('@/assets/file-s-0.png')" alt="files" class="tree-icon" />
          <!-- 如果没有子节点，显示file.png（普通文件夹图标） -->
          <img v-else :src="require('@/assets/file-b-0.png')" alt="file" class="tree-icon" />
          <span>{{ node.label }}</span>
        </span>
      </el-tree>
    </div>
    <div class="page-content" style="flex:1;margin-left:0;">
      <div class="border-bottom" style="margin-top:0;">
        <el-form :inline="true" :model="queryParams" class="demo-form-inline">
          <el-form-item label="用户名称" prop="username">
            <el-input clearable v-model="queryParams.username" placeholder="请输入用户名称进行查询"
              class="form-item-width"></el-input>
          </el-form-item>
          <div class="btn-boxs">
            <div>
              <el-button icon="el-icon-plus" type="primary" @click="handledeptAdd">新 增</el-button>
              <el-button :disabled="!multipleSelection.length" icon="el-icon-delete" type="danger"
                @click="batchDelete">批量删除</el-button>
            </div>
            <div>
              <el-button icon="el-icon-search" type="primary" @click="onSearch">查 询</el-button>
              <el-button icon="el-icon-refresh" @click="onReset">重 置</el-button>
            </div>
          </div>
        </el-form>
      </div>
      <div class="margin-top">
        <!-- 表格组件 -->
        <el-table v-loading="tableLoading" :data="tableData" border style="width: 100%" highlight-current-row
          max-height="447" :header-cell-style="{ background: '#fafafa', color: '#606266', fontSize: '14px' }"
          @selection-change="handleSelectionChange">
          <!-- 多选 -->
          <el-table-column type="selection" width="55"></el-table-column>
          <!-- 序号列 -->
          <el-table-column align="center" type="index" label="序号" width="50"></el-table-column>
          <!-- 动态生成其他列 -->
          <el-table-column align="center" v-for="tab in tableTitle" :key="tab.code" :label="tab.name"
            show-overflow-tooltip :width="tab.width">
            <template slot-scope="scope">
              <!-- 针对 status 列的特殊处理 -->
              <span v-if="tab.code === 'status'"
                :style="scope.row.status === '0' ? { color: 'green', cursor: 'pointer' } : { color: 'red', cursor: 'pointer' }">
                {{
        scope.row.status === '0' ? '正常' : '停用' }}
              </span>
              <!-- 针对 sex 列的特殊处理 -->
              <span v-else-if="tab.code === 'sex'">
                {{
        scope.row.sex === '0' ? '男' :
          scope.row.sex === '1' ? '女' :
            '未知'
      }}
              </span>
              <!-- 其他列的常规展示 -->
              <span v-else>{{ scope.row[tab.code] }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="操作" width="120">
            <template slot-scope="scope">
              <el-button type="text" @click="updateData(scope.row)" class="update-btn">修改</el-button>
              <el-button style="color:red" type="text" @click="deleteData(scope.row)" class="update-btn">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页组件 -->
        <div>
          <Pagination background :total="pageParams.total" :page="pageParams.pageNum" :limit="pageParams.pageSize"
            @pagination="onChangePages" />
        </div>
      </div>
      <!-- 添加 修改部门 -->
      <el-dialog :title="dialogTitle" :visible.sync="deptFormVisible" width="30%" @close="handleDialogClose">
        <el-form :model="form" :rules="rules" ref="form" label-width="100px">
          <el-form-item required label="当前所选部门" label-width="128px">
            <span style="color:red">{{ selectDeptName }}</span>
          </el-form-item>
          <el-form-item label="用户名称" prop="username">
            <el-input v-model="form.username" autocomplete="off" placeholder="请选择用户名称"></el-input>
          </el-form-item>
          <el-form-item label="用户昵称" prop="nickName">
            <el-input v-model="form.nickName" autocomplete="off" placeholder="请选择用户昵称"></el-input>
          </el-form-item>
          <el-form-item label="用户性别" prop="sex">
            <el-select v-model="form.sex" placeholder="请选择性别">
              <el-option label="男" value="0"></el-option>
              <el-option label="女" value="1"></el-option>
              <el-option label="未知" value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="用户类型" prop="userType">
            <el-select v-model="form.userType" placeholder="请选择用户类型">
              <el-option label="系统用户" value="00"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="用户角色" prop="roleIds">
            <el-select multiple v-model="form.roleIds" placeholder="请选择用户角色">
              <el-option v-for="item in roleList" :key="item.roleId" :label="item.roleName"
                :value="item.roleId"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="账号状态" prop="status">
            <el-select v-model="form.status" placeholder="请选择账号状态">
              <el-option label="正常" value="0"></el-option>
              <el-option label="停用" value="1"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button :icon="dialogTitle === '新增' ? 'el-icon-plus' : 'el-icon-edit'" type="primary"
            @click="submitForm('form')">{{ dialogTitle === '新增' ? '立即添加' : '立即修改' }}</el-button>
          <el-button icon="el-icon-refresh" @click="resetForm('form')">重 置</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import Pagination from "@/components/Pagination";
import { queryUserList, queryUserById, updeteUser,deleteUser,userAdd} from "@/api/admin-service/user";
import { getDeptTree } from "@/api/admin-service/dept";
import { getRoleAll } from "@/api/admin-service/role";
export default {
  components: {
    Pagination
  },
  data() {
    return {
      tableLoading: false,
      form: {
        username: "",
        nickName: "",
        userType: "",
        sex: "",
        status: "",
        roleIds: [] //用户角色
      },
      deptId: "", //新增的时候需要选择部门id
      userId: "", //修改和删除的时候需要这个userId
      rules: {
        username: [
          { required: true, message: "请填写用户名称", trigger: "blur" }
        ],
        nickName: [
          { required: true, message: "请填写用户昵称", trigger: "blur" }
        ],
        userType: [
          { required: true, message: "请选择用户类型", trigger: "change" }
        ],
        sex: [{ required: true, message: "请选择用户性别", trigger: "change" }],
        roleIds: [
          { required: true, message: "请选择用户角色", trigger: "change" }
        ],
        status: [
          { required: true, message: "请选择部门状态", trigger: "change" }
        ]
      },
      treeData: [],
      filterText: "", // 过滤树的值
      dialogTitle: "",
      updateId: "", //修改数据需要的id
      deptFormVisible: false,
      // 表格数据
      tableData: [],
      // 表格标题数组
      tableTitle: [
        { name: "用户名称", code: "username", width: "" },
        { name: "用户昵称", code: "nickName", width: "" },
        { name: "用户类型", code: "userType", width: "" },
        { name: "用户性别", code: "sex", width: "" },
        { name: "帐号状态", code: "status", width: "" }
      ],
      defaultProps: {
        children: "children",
        label: "label"
      },
      pageParams: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      queryParams: {
        username: "",
        nickName: "",
        deptId: 0,
        userType: "",
        sex: "",
        status: ""
      },
      selectDeptName: "",
      roleList: [],
      multipleSelection: []
    };
  },
  mounted() {
    this.onGetDataList();
    this.queryRoleList();
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    }
  },
  methods: {
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    batchDelete() {
      this.$confirm(`提示，确定要删除选中的这些数据吗？`, {
        title: "提示",
        showCancelButton: true,
        confirmButtonText: "确 定",
        cancelButtonText: "取 消",
        type: "warning",
        // 为按钮添加图标并设置为 mini 尺寸
        confirmButtonClass: "el-icon-check el-button--mini", // 确定按钮的图标和尺寸
        cancelButtonClass: "el-icon-close el-button--mini" // 取消按钮的图标和尺寸
      })
        .then(() => {
          // 使用 map() 来获取 userId 组成的数组
          const ids = (this.multipleSelection || []).map(item => item.userId);
          deleteUser({ ids }).then(res => {
            if (res?.data) {
              this.$message.success(res.msg || "删除成功");
              this.onGetDataList();
            }
          });
        })
        .catch(error => {
          console.log(error);
          // 取消删除时显示提示
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    // 增 / 改
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.dialogTitle === "新增") {
            const formData = { ...this.form };
            delete formData.userId; // 清除 userId
            // 新增用户
            userAdd({
              ...formData,
              deptId: this.deptId
            }).then(res => {
              if (res.data) {
                this.$message.success(res.msg || "新增成功！");
              } else {
                this.$message.error("新增失败," + res?.msg);
              }
              this.deptFormVisible = false;
              this.queryTableData(this.deptId);
            });
          } else {
            // 如果是超级管理员 不允许修改，这里代码没写完
            updeteUser({
              ...this.form,
              userId: this.userId
            }).then(r => {
              if (r.data || r.code === 200 || r.code === "200") {
                this.$message.success(r.msg || "修改成功！");
                this.deptFormVisible = false;
                this.queryTableData(this.deptId);
              }
            });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 删
    deleteData(row) {
      this.$confirm("提示,确定要删除这条数据吗", {
        title: "提示",
        showCancelButton: true,
        confirmButtonText: "确 定",
        cancelButtonText: "取 消",
        type: "warning",
        // 为按钮添加图标并设置为 mini 尺寸
        confirmButtonClass: "el-icon-check el-button--mini", // 确定按钮的图标和尺寸
        cancelButtonClass: "el-icon-close el-button--mini" // 取消按钮的图标和尺寸
      })
        .then(() => {
          deleteUser({ ids: [row.userId] }).then(res => {
            if (res?.data) {
              this.$message.success(res.msg || "删除成功");
              this.queryTableData(this.deptId);
            }
          });
        })
        .catch(error => {
          console.log(error);
          // 取消删除时显示提示
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    // 改
    updateData(row) {
      this.deptId = row.deptId;
      this.dialogTitle = "修改";
      this.deptFormVisible = true;
      this.selectDeptName = row.deptName;
      queryUserById({ id: row.userId }).then(res => {
        Object.assign(this.form, res?.data);
        this.userId = res.data.userId;
      });
      if (this.dialogTitle === "新增") {
        this.deptId = "";
      }
    },
    // 查
    onGetDataList() {
      getDeptTree({}).then(res => {
        this.queryTableData(res.data[0].deptId); //进入页面默认查询最高级的组织数据
        this.treeData = res.data;
      });
    },
    handleNodeClick(node) {
      this.deptId = node.deptId;
      this.selectDeptName = node.deptName;
      this.queryTableData(node.deptId);
    },
    queryTableData(deptId) {
      this.tableLoading = true;
      queryUserList({
        ...this.pageParams,
        ...this.queryParams,
        deptId
      })
        .then(res => {
          const { records, total } = res?.data;
          this.tableData = records.map(item => {
            // 将角色ID数组映射成对应的角色名称
            const roleNames = (item.roleIds || []).map(roleId => {
              const role = this.roleList.find(role => role.roleId === roleId);
              return role ? role.roleName : ""; // 如果没有找到对应的角色，返回空字符串
            });
            return {
              ...item,
              roleIds: roleNames, // 将roleIds替换成中文角色名称
              userType: "系统用户"
            };
          });
          this.pageParams.total = total || 0;
        })
        .finally(() => {
          this.tableLoading = false;
        });
    },

    handledeptAdd() {
      if (this.deptId === "") {
        this.$message.error("请点击右侧组织树之后在进行新增操作!");
        return;
      }
      this.dialogTitle = "新增";
      this.deptFormVisible = true;
    },
    queryRoleList() {
      getRoleAll({ roleName: "" }).then(res => {
        this.roleList = res.data;
      });
    },
    handleDialogClose() {
      this.resetForm("form");
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    // 公共查询逻辑
    handleSearchOrReset() {
      this.deptId === ""
        ? this.onGetDataList()
        : this.queryTableData(this.deptId);
    },
    // 查询
    onSearch() {
      this.handleSearchOrReset();
    },
    // 重置
    onReset() {
      this.pageParams.pageNum = 1;
      this.pageParams.pageSize = 10;
      this.queryParams.username = "";
      this.handleSearchOrReset();
    },
    // 分页方法
    onChangePages(pageInfo) {
      this.pageParams.pageNum = pageInfo.page;
      this.pageParams.pageSize = pageInfo.limit;
      this.queryTableData(this.deptId);
      // this.onGetDataList();
    }
  }
};
</script>
<style lang="less" scoped>
.analyse-container {
  display: flex;
  // height: 95vh;
}

.form-item-width {
  width: 250px;
}

.right-btns {
  position: absolute;
  right: 20px !important;
}

.border-bottom {
  border-bottom: 1px solid #e2e2e4;
}

.margin-top {
  margin-top: 15px;
}

.custom-tree-node {
  display: flex;
  width: 100%;
  align-items: center;

  .tree-node-label {
    font-size: 12px;
    font-weight: bold;
  }
}

/* 修改当前高亮节点的背景颜色 */
.el-tree .el-tree-node.is-current {
  background-color: #f0f0f0 !important;
  color: #333 !important;
}
</style>
